export default "__VITE_ASSET__sspMG8oX__"